import types from '../mutation-types';
import KnowledgeSourcesAPI from '../../api/knowledgeSources';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isIngesting: false,
  },
};

export const getters = {
  getSources($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  getSource: $state => id => {
    return $state.records.find(record => record.id === Number(id)) || {};
  },
};

export const actions = {
  get: async ({ commit }) => {
    commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isFetching: true });
    try {
      const response = await KnowledgeSourcesAPI.get();
      commit(types.SET_KNOWLEDGE_SOURCES, response.data.payload);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, sourceData) => {
    commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isCreating: true });
    try {
      const response = await KnowledgeSourcesAPI.create({
        knowledge_source: sourceData,
      });
      commit(types.ADD_KNOWLEDGE_SOURCE, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...sourceData }) => {
    commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isUpdating: true });
    try {
      const response = await KnowledgeSourcesAPI.update(id, {
        knowledge_source: sourceData,
      });
      commit(types.EDIT_KNOWLEDGE_SOURCE, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isDeleting: true });
    try {
      await KnowledgeSourcesAPI.delete(id);
      commit(types.DELETE_KNOWLEDGE_SOURCE, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isDeleting: false });
    }
  },

  ingest: async ({ commit }, id) => {
    commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isIngesting: true });
    try {
      const response = await KnowledgeSourcesAPI.ingest(id);
      commit(types.EDIT_KNOWLEDGE_SOURCE, response.data);
      return response.data;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_KNOWLEDGE_SOURCES_UI_FLAG, { isIngesting: false });
    }
  },
};

export const mutations = {
  [types.SET_KNOWLEDGE_SOURCES_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },
  [types.SET_KNOWLEDGE_SOURCES]($state, data) {
    $state.records = data;
  },
  [types.ADD_KNOWLEDGE_SOURCE]($state, data) {
    $state.records.push(data);
  },
  [types.EDIT_KNOWLEDGE_SOURCE]($state, data) {
    const index = $state.records.findIndex(record => record.id === data.id);
    if (index !== -1) {
      $state.records.splice(index, 1, data);
    }
  },
  [types.DELETE_KNOWLEDGE_SOURCE]($state, id) {
    $state.records = $state.records.filter(record => record.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
